import React from "react";

import "./index.scss";

export default function Loader() {
  return (
    <div className="loader__wrapper">
      <div className="loader"></div>
    </div>
  );
}
